import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteFeldOptionCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteFeldOptionCommandService],
  exports: []
})
export class DeleteFeldOptionCommandServiceModule { }
